var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateView',[_c('div',{staticClass:"container"},[(
        _vm.$userCheckAccess({ checkUserType: 'superadmin' }) ||
        _vm.$userCheckAccess({ abilities: 'view_notifications' })
      )?_c('div',{staticClass:"d-flex flex-wrap mb-8"},_vm._l((_vm.list),function(page,p){return _c('BaseButton',{key:'button_' + p,attrs:{"text":page.text,"style-type":"chip","disabled":_vm.$route.name === page.toName || _vm.$route.name === page.toName + 'Edit'},on:{"click":function($event){return _vm.$router.push({ name: page.toName })}}})}),1):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }